import React from 'react';

/**
 * Optional `groupOrder` pins section sequence to the caller's list (keys that have rows only).
 * When omitted or empty, section order is first appearance of each group in rowData.
 */
const groupRowsInDisplayOrder = ({ rowData, getGroupKey, groupOrder }) => {
  const groupKeysInOrder = [];
  const rowsByGroupKey = new Map();

  rowData.forEach((row) => {
    const groupKey = getGroupKey(row);
    if (!rowsByGroupKey.has(groupKey)) {
      groupKeysInOrder.push(groupKey);
      rowsByGroupKey.set(groupKey, []);
    }
    rowsByGroupKey.get(groupKey).push(row);
  });

  let orderedGroupKeys = groupKeysInOrder;

  if (groupOrder?.length) {
    orderedGroupKeys = groupOrder.filter((groupKey) =>
      rowsByGroupKey.has(groupKey)
    );
  }

  return orderedGroupKeys.map((groupKey) => ({
    groupKey,
    rows: rowsByGroupKey.get(groupKey),
  }));
};

const buildGroupedPrintSections = ({
  rowData,
  columns,
  getGroupKey,
  groupOrder,
  getSectionHeaderProps,
  getSectionKpiData,
  ReportHeaderComponent,
}) => {
  const groupedSections = groupRowsInDisplayOrder({ rowData, getGroupKey, groupOrder });

  return groupedSections.map((section, sectionIndex) => {
    const headerProps = getSectionHeaderProps({
      groupKey: section.groupKey,
      rows: section.rows,
      sectionIndex,
    });
    const sectionKpiData = getSectionKpiData?.({
      groupKey: section.groupKey,
      rows: section.rows,
      sectionIndex,
    });

    return {
      ReportHeader: <ReportHeaderComponent {...headerProps} />,
      rowData: section.rows,
      columns,
      kpiData: sectionKpiData ?? [],
    };
  });
};

export { groupRowsInDisplayOrder, buildGroupedPrintSections };
